import { FC, Fragment } from 'react';

import { Label } from '../../../../components/ui/Label';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '../../../../components/ui/Select';
import { Universe } from '../../../../types';

interface Props {
    universes: Universe[];
    selectedUniverseId?: number | null;
    onUniverseChange?: (universeId: number) => void;
    productTypes: Universe['product_types'];
    selectedProductTypeId?: number | null;
    onProductTypeChange?: (productTypeId: number) => void;
    panel?: boolean;
}

export const ProductContextSelectors: FC<Props> = ({
    universes,
    selectedUniverseId,
    onUniverseChange,
    productTypes,
    selectedProductTypeId,
    onProductTypeChange,
    panel = false,
}) => {
    const Wrapper = panel ? 'div' : Fragment;
    const wrapperProps = panel
        ? {
              className:
                  'grid gap-3 rounded-2xl border bg-muted/20 p-3 sm:grid-cols-2 sm:p-4',
              'data-testid': 'bulk-offer-context',
          }
        : {};

    return (
        <Wrapper {...wrapperProps}>
            {onUniverseChange && universes.length > 0 && (
                <div className={panel ? 'space-y-1.5' : undefined}>
                    {panel && (
                        <Label htmlFor="offer-universe-select">Гра</Label>
                    )}
                    <Select
                        value={selectedUniverseId?.toString()}
                        onValueChange={(value) =>
                            onUniverseChange(Number(value))
                        }
                    >
                        <SelectTrigger
                            id="offer-universe-select"
                            className="h-8 text-sm sm:h-9"
                        >
                            <SelectValue placeholder="Оберіть гру" />
                        </SelectTrigger>
                        <SelectContent>
                            {universes.map((universe) => (
                                <SelectItem
                                    key={universe.id}
                                    value={universe.id.toString()}
                                >
                                    {universe.name}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>
            )}

            {onProductTypeChange && productTypes.length > 0 && (
                <div className={panel ? 'space-y-1.5' : undefined}>
                    {panel && (
                        <Label htmlFor="offer-product-type-select">Тип</Label>
                    )}
                    <Select
                        value={selectedProductTypeId?.toString()}
                        onValueChange={(value) =>
                            onProductTypeChange(Number(value))
                        }
                    >
                        <SelectTrigger
                            id="offer-product-type-select"
                            className="h-8 text-sm sm:h-9"
                        >
                            <SelectValue placeholder="Оберіть тип продукту" />
                        </SelectTrigger>
                        <SelectContent>
                            {productTypes.map((productType) => (
                                <SelectItem
                                    key={productType.id}
                                    value={productType.id.toString()}
                                >
                                    {productType.name}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>
            )}

            {panel && (
                <p className="text-xs text-muted-foreground sm:col-span-2">
                    Ці налаштування застосовуються до всіх нових пропозицій.
                </p>
            )}
        </Wrapper>
    );
};
